export default __webpack_public_path__ + "static/media/international_duration.325d0d4d.svg";